export enum EventTypes {
  blur = 'blur',
  change = 'click',
}
